"use client";
import React from "react";
import { PiCaretDoubleLeft, PiCaretDoubleRight } from "@/components/icons";
import { useArticleNavigate } from "./ArticlePageWrapper";
import Paragraph from "@/components/ui/Paragraph";

interface ArticlePaginationNavProps {
  currentPage: number;
  totalPages: number;
  paginationBase: string;
}

export default function ArticlePaginationNav({
  currentPage,
  totalPages,
  paginationBase,
}: ArticlePaginationNavProps) {
  const navigate = useArticleNavigate();

  return (
    <div className="grid grid-cols-3 items-center mt-17.5 mb-10">
      <div>
        {currentPage > 1 ? (
          <button
            onClick={() => navigate(`${paginationBase}?page=${currentPage - 1}`)}
            className="flex cursor-pointer items-center gap-2 py-2.75 hover:px-3.75 uppercase transition-all duration-300 hover:bg-accent-gold text-accent-gold hover:text-accent-brown relative after:absolute sm:after:content-[''] sm:after:w-full sm:after:h-px sm:after:bg-accent-gold after:left-0 after:bottom-0"
          >
            <PiCaretDoubleLeft className="text-2xl sm:text-xl" />
            <span className="max-sm:hidden text-sm">prev page</span>
          </button>
        ) : (
          <span className="flex items-center gap-2 py-2.75 uppercase text-white/20 cursor-not-allowed">
            <PiCaretDoubleLeft className="text-2xl sm:text-xl" />
            <span className="max-sm:hidden text-sm">prev page</span>
          </span>
        )}
      </div>
      <div className="flex justify-center">
        <Paragraph className="font-kode-mono text-xs font-medium text-white/50 leading-[160%] [&>span]:text-white">
          Page <span>{currentPage}</span> of <span>{totalPages}</span>
        </Paragraph>
      </div>
      <div className="flex justify-end">
        {currentPage < totalPages ? (
          <button
            onClick={() => navigate(`${paginationBase}?page=${currentPage + 1}`)}
            className="flex items-center cursor-pointer gap-2 py-2.75 hover:px-3.75 uppercase transition-all duration-300 hover:bg-accent-gold text-accent-gold hover:text-accent-brown relative after:absolute sm:after:content-[''] sm:after:w-full sm:after:h-px sm:after:bg-accent-gold after:left-0 after:bottom-0"
          >
            <span className="max-sm:hidden text-sm">next page</span>
            <PiCaretDoubleRight className="text-2xl sm:text-xl" />
          </button>
        ) : (
          <span className="flex items-center gap-2 py-2.75 uppercase text-white/20 cursor-not-allowed">
            <span className="max-sm:hidden text-sm">next page</span>
            <PiCaretDoubleRight className="text-2xl sm:text-xl" />
          </span>
        )}
      </div>
    </div>
  );
}
